import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { PreviewListState } from '../reducers/preview-list.reducer';
import * as selectors from '../selectors/preview-list.selectors';

@Injectable()
export class PreviewListFacadeService extends FacadeService {
  constructor(public override store: Store<PreviewListState>) {
    super(store);
  }

  // OBSERVABLES

  displayedColumns$ = this.storeSelect(selectors.getDisplayedColumns);
  displayedColumnKeys$ = this.storeSelect(selectors.getDisplayedColumnKeys);
  previewListData$ = this.storeSelect(selectors.getPreviewListData);
  excludedColumnKeys$ = this.storeSelect(selectors.getExcludedColumnKeys);
  loyaltyMemberId$ = this.storeSelect(selectors.getLoyaltyMemberId);
  totalResults$ = this.storeSelect(selectors.getTotalResults);
  itemsNumber$ = this.storeSelect(selectors.getItemsNumber);
  pageIndex$ = this.storeSelect(selectors.getPageIndex);
  personId$ = this.storeSelect(selectors.getPersonId);
  pageSize$ = this.storeSelect(selectors.getPageSize);
  campaignAdHocListId$ = this.storeSelect(selectors.getCampaignAdHocListId);

  // OBSERVABLE'S VALUES

  get previewListData() {
    return this.storeSnapshot(this.previewListData$);
  }

  get excludedColumnKeys() {
    return this.storeSnapshot(this.excludedColumnKeys$);
  }

  get loyaltyMemberId() {
    return this.storeSnapshot(this.loyaltyMemberId$);
  }

  get personId() {
    return this.storeSnapshot(this.personId$);
  }

  get pageIndex() {
    return this.storeSnapshot(this.pageIndex$);
  }

  get pageSize() {
    return this.storeSnapshot(this.pageSize$);
  }

  get campaignAdHocListId() {
    return this.storeSnapshot(this.campaignAdHocListId$);
  }

  get itemsNumber() {
    return this.storeSnapshot(this.itemsNumber$);
  }
}
